export default {"src":"/intl/_next/static/media/loading.b2fc8299.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};